import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { UserService } from './user.service';
import { environment } from 'src/environments/environment';

export interface Params {
    site: string;
}

@Injectable({
    providedIn: 'root',
})
export class AuthGuard  {
    //site;
    params: any;
    isAuthenticated!: boolean;

    constructor(private router: Router, private userService: UserService) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/login');
            return false;
        }

        return true;
    }
}
